import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [
    {
      path: "notifications",
      lazy: page(() => import("./NotificationsPage")),
      handle: shows("notifications"),
    },
  ],
};
